import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
	providedIn: 'root'
})
export class CloudServiceService {
	constructor(private readonly http: HttpClient) {}

	public baseUrl = environment.cloudFunction.baseUrl;

	public doPost(apiUrl, reqBody, successCallback, failureCallback) {
		this.http.post(apiUrl, reqBody).subscribe(
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}

	public logToStack(
		userId: string,
		event: string,
		logType: string,
		messageBody: object,
		successCallback,
		failureCallback
	) {
		const apiUrl = `${this.baseUrl}/stack/applogging`;
		const reqBody = {
			event,
			logType,
			appName: environment.appName,
			message: messageBody,
			userId: userId || 'NA'
		};
		this.doPost(
			apiUrl,
			reqBody,
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}

	public postDataToBigQuery(data, successCallback, failureCallback) {
		const apiUrl = `${this.baseUrl}/auditreports/create`;
		let reqBody;
		if (data.email) {
			reqBody = {
				datasetId: 'Audit_Logs',
				tableId: 'reports',
				auditLogData: {
					LOG_TYPE: 'INFO',
					EMAIL_ID: data.email,
					USER_ID: data.userId,
					USER_TYPE: data.userType,
					EVENT_NAME: 'STAFF UPDATE',
					ACTIVITY_STATUS: data.activityStatus,
					OPERATIONAL_STATUS: 'POST',
					AUDIT_PAYLOAD: data.payLoad,
					COMMENTS: 'LOG FOR STUDENT UPSERT',
					CREATED_BY: 'DRC-FRONTEND',
					EVENT_TYPE: data.eventType
				}
			};
		} else {
			reqBody = {
				datasetId: 'Audit_Logs',
				tableId: 'reports',
				auditLogData: {
					LOG_TYPE: 'ERROR',
					EMAIL_ID: null,
					USER_ID: null,
					USER_TYPE: data.userType,
					EVENT_NAME: 'STAFF UPDATE',
					ACTIVITY_STATUS: data.activityStatus,
					OPERATIONAL_STATUS: 'POST',
					AUDIT_PAYLOAD: data.payLoad,
					COMMENTS: 'LOG ERROR FOR STUDENT HOME COMPONENT',
					CREATED_BY: 'DRC-FRONTEND',
					EVENT_TYPE: data.eventType
				}
			};
		}
		this.doPost(
			apiUrl,
			reqBody,
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}
}
